import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';

const AddForYouCategory = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [name, setName] = useState('');
  const [category, setCategory] = useState('');

  const validateForm = () => {
    if (!name.trim()) {
      toast.error('Name is required.');
      return false;
    }
    if (!category) {
      toast.error('Category is required.');
      return false;
    }
    return true;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validateForm()) return;

    setIsLoading(true);

    try {
      const payload = {
        name,
        category,
      };

      const request = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/for-you-category/create-foryou-category`,
        payload
      );

      if (request.data.success) {
        toast.success('Category created successfully!');
        setTimeout(() => navigate('/for-you-category'), 3000);
      } else {
        toast.error('Could not create category');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={containerStyle}>
      <ToastContainer />
      <div className="shadow rounded" style={cardStyle}>
        <div style={sectionTitleStyle}>
          <h3 style={titleTextStyle}>Add For You Category</h3>
        </div>
        <div style={userInfoContainer}>
          {/* Name Field */}
          <div style={profileFieldStyle}>
            <label style={profileLabelStyle}>Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              style={profileInputStyle}
              placeholder="Enter category name"
              maxLength={20} // This limits the input to 20 characters
              required
            />
          </div>

          {/* Category Dropdown */}
          <div style={profileFieldStyle}>
            <label style={profileLabelStyle}>Category Type</label>
            <select
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              style={profileInputStyle}
              required
            >
              <option value="">Select Category</option>
              <option value="free">Free</option>
              <option value="Paid">Paid</option>
            </select>
          </div>
        </div>
      </div>

      {/* Submit Button */}
      <div className="add-btn-align-category">
        <Button
          type="submit"
          style={buttonStyle}
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? 'Add' : 'Add'}
        </Button>
      </div>
    </div>
  );
};

// Inline Styles
const containerStyle = {
  maxWidth: '90%',
  fontFamily: 'Poppins',
  fontWeight: 600,
};

const cardStyle = {
  backgroundColor: 'white',
  borderRadius: '8px',
  marginBottom: '20px',
  border: 'none',
  width: '80%',
};

const sectionTitleStyle = {
  color: 'white',
  backgroundColor: '#064260',
  padding: '10px',
  borderRadius: '8px 8px 0 0',
  textAlign: 'left',
  fontWeight: 600,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
};

const titleTextStyle = {
  fontSize: '21px',
  margin: 0,
};

const buttonStyle = {
  backgroundColor: '#27B99A',
  color: 'white',
  border: 'none',
  borderRadius: '20px',
  fontSize: '16px',
  cursor: 'pointer',
  width: '15%',
  marginRight: '30px',
};

const userInfoContainer = {
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 40px',
  gap: '20px',
};

const profileFieldStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
};

const profileLabelStyle = {
  fontWeight: 'bold',
  fontSize: '14px',
};

const profileInputStyle = {
  padding: '8px',
  borderRadius: '4px',
  backgroundColor: '#F4F4F6',
  border: 'none',
  width: '100%',
};

export default AddForYouCategory;
